// Indian mobile numbers: 10 digits starting 6-9, optionally written with +91, 91 or 0 in front
const INDIAN_MOBILE = /^[6-9]\d{9}$/;

export const normalizePhone = (value) => {
    const digits = String(value || '').replace(/\D/g, '');
    if (digits.length === 12 && digits.startsWith('91')) return digits.slice(2);
    if (digits.length === 11 && digits.startsWith('0')) return digits.slice(1);
    return digits;
};

export const isValidPhone = (value) => INDIAN_MOBILE.test(normalizePhone(value));

// Country codes offered at checkout. India first: it's the store's home market.
export const COUNTRIES = [
    { code: 'IN', dial: '91', flag: '🇮🇳', name: 'India' },
    { code: 'AE', dial: '971', flag: '🇦🇪', name: 'UAE' },
    { code: 'US', dial: '1', flag: '🇺🇸', name: 'USA / Canada' },
    { code: 'GB', dial: '44', flag: '🇬🇧', name: 'United Kingdom' },
    { code: 'SA', dial: '966', flag: '🇸🇦', name: 'Saudi Arabia' },
    { code: 'QA', dial: '974', flag: '🇶🇦', name: 'Qatar' },
    { code: 'SG', dial: '65', flag: '🇸🇬', name: 'Singapore' },
    { code: 'AU', dial: '61', flag: '🇦🇺', name: 'Australia' },
    { code: 'NP', dial: '977', flag: '🇳🇵', name: 'Nepal' },
    { code: 'BD', dial: '880', flag: '🇧🇩', name: 'Bangladesh' },
    { code: 'LK', dial: '94', flag: '🇱🇰', name: 'Sri Lanka' }
];

const TIMEZONE_COUNTRY = {
    'Asia/Kolkata': 'IN', 'Asia/Calcutta': 'IN', 'Asia/Dubai': 'AE', 'Europe/London': 'GB',
    'Asia/Riyadh': 'SA', 'Asia/Qatar': 'QA', 'Asia/Singapore': 'SG', 'Asia/Kathmandu': 'NP',
    'Asia/Dhaka': 'BD', 'Asia/Colombo': 'LK', 'Australia/Sydney': 'AU', 'Australia/Melbourne': 'AU'
};

// Picks the country from the device's time zone first (many Indian phones use en-US as
// their language), then the language region, falling back to India
export const detectCountry = () => {
    try {
        const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (TIMEZONE_COUNTRY[zone]) return TIMEZONE_COUNTRY[zone];
        const region = (navigator.language || '').split('-')[1];
        if (region && COUNTRIES.some(c => c.code === region.toUpperCase())) return region.toUpperCase();
        if (zone && zone.startsWith('America/')) return 'US';
    } catch (e) { }
    return 'IN';
};

export const getCountry = (code) => COUNTRIES.find(c => c.code === code) || COUNTRIES[0];

// Finds a country from a number typed/pasted with a + prefix, e.g. "+971 50 123 4567"
export const matchDialCode = (value) => {
    const digits = String(value || '').replace(/\D/g, '');
    if (!String(value || '').trim().startsWith('+')) return null;
    const match = [...COUNTRIES].sort((a, b) => b.dial.length - a.dial.length).find(c => digits.startsWith(c.dial));
    return match ? { country: match.code, number: digits.slice(match.dial.length) } : null;
};

// Stored phones: Indian numbers as plain 10 digits (existing data), others as +<dial><number>
export const parseStoredPhone = (stored) => {
    const matched = matchDialCode(stored);
    if (matched) return matched;
    return { country: 'IN', number: normalizePhone(stored) };
};

export const isValidPhoneFor = (country, number) => {
    const digits = String(number || '').replace(/\D/g, '');
    return country === 'IN' ? isValidPhone(digits) : /^\d{6,14}$/.test(digits);
};

export const toStoredPhone = (country, number) => {
    const digits = String(number || '').replace(/\D/g, '');
    return country === 'IN' ? normalizePhone(digits) : `+${getCountry(country).dial}${digits}`;
};
